import type { IOnboardingStepText } from '../../types/IOnboardingStepText'

export const improvementsTexts: Record<string, IOnboardingStepText> = {
  'improvements.intro': {
    title: 'Предложения по улучшению',
    text: 'Любой сотрудник может предложить, как улучшить работу. Предложение рассматривает комиссия во главе с председателем.',
  },
  'improvements.create': {
    title: 'Предложить',
    text: 'Опишите идею и ожидаемый результат. Покажем главные поля формы.',
  },
  'improvements.create.type': {
    title: 'Вид ППУ',
    text: 'От вида зависит, какая комиссия и председатель будут рассматривать предложение.',
  },
  'improvements.create.anonymous': {
    title: 'Анонимно',
    text: 'Автор не будет виден в ленте и карточке.',
  },
  'improvements.settings': {
    title: 'Настройки',
    text: 'Эксперты и виды ППУ. Доступно администраторам модуля.',
  },
  'improvements.navSettings': {
    title: 'Настройки в боковом меню',
    text: 'Те же настройки открываются с любой страницы: наведите на пункт «Предложения по улучшению» в боковом меню — появится шестерёнка.',
  },
  'improvements.settings.intro': {
    title: 'Настройки ППУ',
    text: 'Здесь настраиваются эксперты комиссий и виды предложений.',
  },
  'improvements.settings.expertsTab': {
    title: 'Эксперты',
    text: 'Общий список экспертов. Из него председатель выбирает, кто будет голосовать по предложению.',
  },
  'improvements.settings.typesTab': {
    title: 'Виды ППУ',
    text: 'У каждого вида свой председатель комиссии. Неактивный вид нельзя выбрать при создании предложения.',
  },
  'improvements.settings.createType': {
    title: 'Новый вид',
    text: 'Добавьте вид предложения и назначьте председателя комиссии.',
  },
  'improvements.registry': {
    title: 'Реестр',
    text: 'Все предложения таблицей — с фильтрами по видам, стадиям и датам.',
  },
  'improvements.rating': {
    title: 'Рейтинг',
    text: 'Кто из сотрудников подаёт больше предложений и сколько из них принято.',
  },
  'improvements.rating.table': {
    title: 'Рейтинг авторов',
    text: 'Сколько предложений подал каждый сотрудник и сколько из них принято.',
  },
  'improvements.requiresAction': {
    title: 'Требует действия',
    text: 'Покажет только предложения, где ждут именно вас.',
  },
  'improvements.filter': {
    title: 'Фильтр',
    text: 'Отбор по автору и статусу: мои предложения, моего отделения, принятые и т.д.',
  },
  'improvements.demoCard': {
    title: 'Карточка предложения',
    text: 'Статус, стадия рассмотрения и оценки коллег. Когда решение принято, оно появится внизу карточки. Клик открывает карточку — откроем учебную.',
  },
  'improvements.registry.intro': {
    title: 'Реестр ППУ',
    text: 'Все предложения портала в одной таблице.',
  },
  'improvements.registry.search': {
    title: 'Поиск',
    text: 'Введите слово или номер и нажмите Enter.',
  },
  'improvements.registry.requiresAction': {
    title: 'Требует действия',
    text: 'Покажет только предложения, где ждут именно вас.',
  },
  'improvements.registry.filters': {
    title: 'Фильтры колонок',
    text: 'Значок в заголовке колонки открывает фильтр по ней.',
  },
  'improvements.registry.resetFilters': {
    title: 'Сброс фильтров',
    text: 'Возвращает таблицу к виду по умолчанию.',
  },
  'improvements.registry.demoRow': {
    title: 'Карточка предложения',
    text: 'Клик по строке открывает карточку. Откроем учебную.',
  },
  'improvements.form.type': {
    title: 'Вид ППУ',
    text: 'Определяет комиссию. Автор может поменять вид, пока предложение у него.',
  },
  'improvements.form.decision': {
    title: 'Решение',
    text: 'Последний комментарий: решение комиссии или замечания к доработке.',
  },
  'improvements.form.reviewTab': {
    title: 'Рассмотрение',
    text: 'Работа комиссии: председатель, эксперты и их голоса.',
  },
  'improvements.form.chair': {
    title: 'Председатель',
    text: 'Ведёт рассмотрение и принимает итоговое решение.',
  },
  'improvements.form.assignExperts': {
    title: 'Эксперты',
    text: 'Председатель выбирает экспертов, которые голосуют «за» или «против».',
  },
  'improvements.form.experts': {
    title: 'Эксперты и голоса',
    text: 'Председатель назначает экспертов из общего списка, каждый голосует «за» или «против». Здесь видно, кто назначен и как проголосовал.',
  },
  'improvements.form.actions': {
    title: 'Решение по предложению',
    text: 'Согласовать, принять, вернуть на доработку или отклонить — кнопки видны тем, кому доступно действие.',
  },
  'improvements.form.vote': {
    title: 'Голосование',
    text: 'Вы эксперт комиссии: проголосуйте и оставьте комментарий.',
  },
  'improvements.form.historyTab': {
    title: 'История',
    text: 'Кто и когда менял предложение.',
  },
  'improvements.form.tasksEar': {
    title: 'Задача комиссии',
    text: 'Появляется, когда предложение дошло до комиссии: в ней председатель ведёт работу и отчитывается.',
  },
}
